@if (discordGift.canClaimGift) {
  <div class="align-items-center m-b-50 offer-container">
    <img src="./assets/images/fsp8-images/fsp-subscription-box.png" class="m-r-20 offer-image" style="max-width: 300px; display: inline-block" width="100%" alt="" />
    <div class="offer-text">
      <!-- Three different things can be waiting here — a free copy, a year of updates on the
           copy they own, or a year of the subscription they pay for. The backend decides which
           (`giftBenefit`); this only renders it. -->
      @if (discordGift.giftBenefit === "subscription_extension") {
        <fui-heading [text]="'discord_migration.free_offer_heading_sub' | translate" level="2" [fontSize]="headingSize"></fui-heading>
        {{ "discord_migration.free_offer_detail_sub" | translate }}
      } @else if (discordGift.giftBenefit === "license_extension") {
        <fui-heading [text]="'discord_migration.free_offer_heading_ext' | translate" level="2" [fontSize]="headingSize"></fui-heading>
        {{ "discord_migration.free_offer_detail_ext" | translate }}
      } @else {
        <fui-heading [text]="'discord_migration.free_offer_heading' | translate" level="2" [fontSize]="headingSize"></fui-heading>
        {{ "discord_migration.free_offer_detail" | translate }}
      }
      <br />
      <br />
      <button type="button" class="btn btn-primary" (click)="claim()">
        @if (discordGift.giftBenefit === "subscription_extension") {
          {{ "discord_migration.claim_button_sub" | translate }}
        } @else if (discordGift.giftBenefit === "license_extension") {
          {{ "discord_migration.claim_button_owner" | translate }}
        } @else {
          {{ "discord_migration.claim_button_new" | translate }}
        }
      </button>
    </div>
  </div>
}
